import React, { useState, useEffect, useRef } from "react";
import "./LatestMembers.css";
import ListItem from "../../components/LatestMember/ListItem";
function LatestMembers() {
  const data = [
    {
      memberName: "Jeremiah Aquino",
      memberPosition: "Frontend Developer",
    },
    {
      memberName: "Francis Reyes",
      memberPosition: "Technical Support Officer",
    },
    {
      memberName: "Mark John Santos",
      memberPosition: "Mobile Developer",
    },
    {
      memberName: "Jean Villanueva",
      memberPosition: "QA Engineer",
    },
  ];
  return (
    <div className='employee-dashboard-latest-members'>
      <h2>Latest Members</h2>
      <div className='latest-member'>
        {data.map((value) => (
          <ListItem memberName={value.memberName} memberPosition={value.memberPosition} />
        ))}
      </div>
    </div>
  );
}
export default LatestMembers;
